/**
 * @fileoverview POST handler for the "/engagement/user/matcher" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementUserMatcherCacheKeys } from "./constants";
import type { PostEngagementUserMatcherProps, EngagementUserMatcherResult } from "./types";

export const postEngagementUserMatcher = reactQueryMutationAdapter(
  engagementUserMatcherCacheKeys,
  (props: PostEngagementUserMatcherProps): Promise<EngagementUserMatcherResult> => {
    return fetch("/engagement/user/matcher", "POST", props);
  }
);
